module.exports = __webpack_public_path__ + "static/editor_screen@2x-d77a99c06b124e98e63023847a48298f.png";